export default __webpack_public_path__ + "static/media/cancer.b47bd370.png";